import React from "react";
import SelectUbicacionModal from "../modales/ubicaciones/SelectUbicacionModal";
import ElegirLugaresModal from "./ElegirLugaresModal";
import { useMapaCompra } from "./MapaCompra";
import { conLugares } from "../../domain/compra/pedido";

// usaMapaNuevo: la tarifa se vende en un sector con lugares de un mapa
// publicado con el editor nuevo
export const usaMapaNuevo = (indice, tarifa) => {
  const t = indice && tarifa ? indice.tarifas[tarifa.id] : null;
  const sector = t ? indice.sectores[t.idubicacion] : null;
  return Boolean(sector && conLugares(sector));
};

// aplicarCambios lleva lo elegido en el mapa a las cantidades y selecciones
// por tarifa de la compra
export const aplicarCambios = (cambios, setCantidad, setAsientosSeleccionados) => {
  setCantidad((prev) => {
    const nuevo = { ...prev };
    Object.entries(cambios).forEach(([id, c]) => {
      nuevo[id] = c.cantidad;
    });
    return nuevo;
  });
  setAsientosSeleccionados((prev) => {
    const nuevo = { ...prev };
    Object.entries(cambios).forEach(([id, c]) => {
      nuevo[id] = c.seleccion;
    });
    return nuevo;
  });
};

// precioLista: lo que muestra la lista de entradas. Una mesa entera con
// paquetes sale "desde" el paquete más barato.
export const precioLista = (indice, tarifa) => {
  const t = indice?.tarifas[tarifa.id];
  if (t?.venta_mesa === "mesa" && t.paquetes.length > 0) {
    return { precio: Math.min(...t.paquetes.map((p) => p.precio)), desde: true };
  }
  return { precio: tarifa.precio, desde: false };
};

// tarifasLigadas: al sacar una mesa entera se van también sus adicionales
export const tarifasLigadas = (indice, idtarifa) =>
  indice?.tarifas[idtarifa]?.adicionales.map((a) => a.idtarifa) || [];

// SelectorLugares abre el mapa nuevo si el evento lo tiene; si no, el
// selector de siempre.
const SelectorLugares = ({
  open,
  onClose,
  tarifa,
  cantidad,
  asientosSeleccionados,
  setCantidad,
  setAsientosSeleccionados,
  ...viejo
}) => {
  const { indice } = useMapaCompra();

  if (usaMapaNuevo(indice, tarifa)) {
    return (
      <ElegirLugaresModal
        open={open}
        onClose={onClose}
        tarifa={tarifa}
        cantidad={cantidad}
        asientosSeleccionados={asientosSeleccionados}
        onAplicar={(cambios) => aplicarCambios(cambios, setCantidad, setAsientosSeleccionados)}
      />
    );
  }
  return <SelectUbicacionModal open={open} onClose={onClose} tarifa={tarifa} {...viejo} />;
};

export default SelectorLugares;
